var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.9999 15.9402C21.9999 18.7302 19.7599 20.9902 16.9699 21.0002H16.9599H7.04988C4.26988 21.0002 1.99988 18.7502 1.99988 15.9602V15.9502C1.99988 15.9502 2.00588 11.5242 2.01388 9.29818C2.01488 8.88018 2.49488 8.64618 2.82188 8.90618C5.19788 10.7912 9.44688 14.2282 9.49988 14.2732C10.2099 14.8422 11.1099 15.1632 12.0299 15.1632C12.9499 15.1632 13.8499 14.8422 14.5599 14.2622C14.6129 14.2272 18.7669 10.8932 21.1789 8.97718C21.5069 8.71618 21.9889 8.95018 21.9899 9.36718C21.9999 11.5762 21.9999 15.9402 21.9999 15.9402Z",
    fill: "#5C58FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.476 5.67357C20.61 4.04157 18.906 2.99957 17.03 2.99957H7.05001C5.17401 2.99957 3.47001 4.04157 2.60401 5.67357C2.41001 6.03857 2.50201 6.49357 2.82501 6.75157L10.25 12.6906C10.77 13.1106 11.4 13.3196 12.03 13.3196C12.034 13.3196 12.037 13.3196 12.04 13.3196C12.043 13.3196 12.047 13.3196 12.05 13.3196C12.68 13.3196 13.31 13.1106 13.83 12.6906L21.255 6.75157C21.578 6.49357 21.67 6.03857 21.476 5.67357Z",
    fill: "#5C58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a1562a0b33d9e1f5de246e09bd65a07d.svg";
export { ForwardRef as ReactComponent };